var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        appendToBody: true,
        title: _vm.uploadTitle,
        visible: _vm.uploadVideoVisible,
        width: "470px",
        "custom-class": "qm-upload-video-dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.uploadVideoVisible = $event
        },
        close: _vm.closeUploadDialog,
      },
    },
    [
      _vm.uploadType == "aliyun"
        ? _c(
            "div",
            [
              _vm.finalStatus == 0
                ? [
                    _c(
                      "div",
                      [
                        _c(
                          "el-upload",
                          {
                            staticClass: "qm-upload__upload-demo",
                            attrs: {
                              drag: "",
                              "auto-upload": false,
                              action: "",
                              "show-file-list": false,
                              "on-change": _vm.uploadChange,
                            },
                          },
                          [
                            _c(
                              "svg",
                              {
                                staticClass: "qm-import__upload-icon",
                                attrs: {
                                  viewBox: "0 0 1024 1024",
                                  width: "200",
                                  height: "200",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M909 897H115a50 50 0 0 1-50-50V177a50 50 0 0 1 50-50h370a50 50 0 0 1 50 50v62a10 10 0 0 0 10 10h241a50 50 0 0 1 50 50v58h73a50 50 0 0 1 50 50v440a50 50 0 0 1-50 50zM505 309a30 30 0 0 1-30-30v-72a20 20 0 0 0-20-20H145a20 20 0 0 0-20 20v610c0 11.046 9.377 20 20.422 20H209a20 20 0 0 0 20-20V407a50 50 0 0 1 50-50h497v-28a20 20 0 0 0-20-20H535m364 128a20 20 0 0 0-20-20H309a20 20 0 0 0-20 20v400h590a20 20 0 0 0 20-20V437zM650.659 615.8l-26.618-26.53V737a30 30 0 0 1-30 30h-0.113a30 30 0 0 1-30-30V589.275L537.309 615.8a30.006 30.006 0 0 1-42.509-42.36l77.928-77.669a30.127 30.127 0 0 1 42.506 0l77.929 77.669a30.007 30.007 0 0 1-42.504 42.36z",
                                  },
                                }),
                              ]
                            ),
                            _c("div", { staticClass: "el-upload__text" }, [
                              _vm._v("支持文件拖拽至框内上传"),
                            ]),
                            _c("el-button", { attrs: { size: "small" } }, [
                              _vm._v("选择文件"),
                            ]),
                            _c("div", { staticClass: "el-upload__tip" }, [
                              _vm._v("支持mp4或mp3格式，大小不超过50M"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm.finalStatus === 1 ||
              _vm.finalStatus === 2 ||
              _vm.finalStatus === 4
                ? [
                    _c(
                      "div",
                      [
                        _c("span", [_vm._v(_vm._s(_vm.videoName))]),
                        _vm.finalStatus === 1
                          ? _c("el-progress", {
                              attrs: { percentage: _vm.authProgress },
                            })
                          : _vm._e(),
                        _vm.finalStatus === 2
                          ? _c("el-progress", {
                              attrs: {
                                percentage: _vm.authProgress,
                                status: "success",
                              },
                            })
                          : _vm._e(),
                        _vm.finalStatus === 4
                          ? _c("el-progress", {
                              attrs: {
                                percentage: _vm.authProgress,
                                status: "exception",
                              },
                            })
                          : _vm._e(),
                        _c("span", [_vm._v(_vm._s(_vm.statusText))]),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm.finalStatus === 3
                ? [
                    _c("div", { staticClass: "qm-upload__img" }, [
                      _c("img", {
                        attrs: {
                          src:
                            _vm.videoForm.coverUrl ||
                            "https://images.qmai.cn/resource/20210824211416/2021/11/30/video-default-img.png",
                          alt: "",
                        },
                      }),
                      _c(
                        "div",
                        {
                          staticClass: "qm-upload__del-btn",
                          on: { click: _vm.delVideo },
                        },
                        [_c("i", { staticClass: "el-icon-delete" })]
                      ),
                    ]),
                  ]
                : _vm._e(),
            ],
            2
          )
        : _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "videoForm",
                  attrs: {
                    model: _vm.videoForm,
                    "status-icon": "",
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "音视频路径：", required: "" } },
                    [
                      _c("el-input", {
                        attrs: { autocomplete: "off" },
                        model: {
                          value: _vm.videoForm.netUrl,
                          callback: function ($$v) {
                            _vm.$set(_vm.videoForm, "netUrl", $$v)
                          },
                          expression: "videoForm.netUrl",
                        },
                      }),
                      _c("span", { staticClass: "qm-upload__url-note" }, [
                        _vm._v("网络音视频路径请联系企迈客服获取"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
      _c(
        "span",
        {
          staticClass: "del-tree-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: {
                disabled: _vm.finalStatus == 1 || _vm.finalStatus == 2,
                size: "small",
              },
              on: { click: _vm.closeUploadDialog },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: {
                disabled: _vm.finalStatus == 1 || _vm.finalStatus == 2,
                size: "small",
                type: "primary",
              },
              on: { click: _vm.addVideoSub },
            },
            [_vm._v("保存")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }